import { render, staticRenderFns } from "./500.vue?vue&type=template&id=122a90bf&scoped=true"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a90bf",
  null
  
)

export default component.exports